import React from "react";
import Env from "../../Env";
import LegalAppBridge from "../../LegalAppBridge";
import GenerationTabContentProduction from "./GenerationTabContentProduction";
import GenerationTabContentDraft from "./GenerationTabContentDraft";

class GenerationTabContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalTemplate: false,
      modalPublishConfirm: false,
      rawHtmlOpen: false,
      showPublishedNotice: false,
    }
    this.rawHtmlControl = 'toggle-raw-html-' + this.props.pageType;
  }

  handleToggleModalTemplate = () => this.setState({ modalTemplate: !this.state.modalTemplate });
  handleToggleModalPublish = () => this.setState({ modalPublishConfirm: !this.state.modalPublishConfirm });
  handleEditorChange = (name, editor) => {
    this.props.handleChangeState(this.props.manualEditingKey, true);
    this.props.handleChangeState(this.props.draftUnSavedKey, true);
    this.props.handleEditorChange(name, editor);
  }

  getTemplate = () => {
    const pageType = this.props.pageType,
      templates = this.props.templates;
    return templates.hasOwnProperty(pageType) ? templates[pageType] : '';
  }

  hasTemplate = () => !!this.getTemplate();

  handleToggleRawHtml = () => this.setState({ rawHtmlOpen: !this.state.rawHtmlOpen });

  handleApplyTemplate = () => {
    this.handleReplaceDraftByTemplate();
    this.handleToggleModalTemplate();
    this.props.handleChangeState(this.props.manualEditingKey, false);
  }

  handleReplaceDraftByTemplate = () => {
    const pageType = this.props.pageType,
      editors = this.props.editors,
      editor = editors[pageType],
      template = this.getTemplate();
    if (template) {
      editor.setData(template);
    }
  }

  handleDismissPublishedNotice = () => this.setState({ showPublishedNotice: false });

  handlePublishPage = () => {
    if (this.props.manualEditing) {
      !this.state.modalPublishConfirm && this.handleToggleModalPublish(); // Open confirmation
    } else {
      this._publishPage();
    }
  }

  _publishPage = () => {
    this.state.modalPublishConfirm && this.handleToggleModalPublish();  // Close confirmation
    this.props.handlePublishPage(this.props.pageType)
      .then(response => {
        if (response.success) {
          LegalAppBridge.toast('Publish page successfully');
          this.setState({ showPublishedNotice: true });   // Show publication notice
        } else {
          LegalAppBridge.toastError(response.reason);
        }
      })
      .catch(error => {
        Env.log('Failed to publish page!', error);
        LegalAppBridge.toastError('Failed to publish page!');
      });
  }

  render() {
    const {
      preDraftContent,
      pageId, pageType, isProduction, saving, publishing,
      prodContent, prodStyle, draftContent,
      handleEditorInitialized,
      handleChangeEnv,
      handleDiscardChange, handleSavePage,
      uploadToken, mentionPool,
    } = this.props;

    return isProduction ?
      <GenerationTabContentProduction
        pageId={pageId} pageType={pageType} handleChangeEnv={handleChangeEnv}
        prodContent={prodContent} prodStyle={prodStyle} token={uploadToken}
        showPublishedNotice={this.state.showPublishedNotice}
        handleDismissPublishedNotice={this.handleDismissPublishedNotice}
        publishing={publishing} handlePublishPageConfirm={this.handlePublishPage} handlePublishPage={this._publishPage}
        modalPublishConfirm={this.state.modalPublishConfirm} handleToggleModalPublish={this.handleToggleModalPublish}
      /> :
      <GenerationTabContentDraft
        pageType={pageType} handleChangeEnv={handleChangeEnv}
        preDraftContent={preDraftContent} draftContent={draftContent}
        draftUnSavedNotice={this.props.draftUnSaved}
        uploadToken={uploadToken} mentionPool={mentionPool}
        handleEditorChange={this.handleEditorChange} handleEditorInitialized={handleEditorInitialized}
        handleDiscardChange={handleDiscardChange}
        hasTemplate={this.hasTemplate} modalTemplate={this.state.modalTemplate}
        handleToggleModalTemplate={this.handleToggleModalTemplate} handleApplyTemplate={this.handleApplyTemplate}
        saving={saving} handleSavePage={handleSavePage}
        rawHtmlOpen={this.state.rawHtmlOpen} rawHtmlControl={this.rawHtmlControl}
        handleToggleRawHtml={this.handleToggleRawHtml}
      />;
  }
}

export default GenerationTabContent;
